<template>
  <div class="tab-content tab-history">
    <report-panel :is-visible.sync="isVisibleReport">
      <template v-slot:content>
        <bar :chartData="chartData" :options="{ responsive: true }" height="200" />
      </template>
    </report-panel>
    <native-scroll v-loading="isLoading">
      <el-table
        :data="tableData"
        border
        :summary-method="getSummaries"
        show-summary>
        <el-table-column
          prop="year"
          :label="L10n('quote-summary-for')">
        </el-table-column>
        <el-table-column
          prop="requested"
          class-name="history-row__requested"
          :label="L10n('number-of-pn-requested')">
        </el-table-column>
        <el-table-column
          prop="quoted"
          class-name="history-row__quoted"
          :label="L10n('number-of-pn-quoted')">
        </el-table-column>
        <el-table-column
          prop="perQuotedToRequested"
          :label="L10n('percent-quoted-to-requested')">
          <template v-slot="{ row }">
            <el-tag size="small">{{row.perQuotedToRequested | toPercent}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="ordered"
          class-name="history-row__ordered"
          :label="L10n('number-of-pn-ordered-following-quote')">
        </el-table-column>
        <el-table-column
          prop="perOrderedToQuoted"
          :label="L10n('percent-ordered-to-quoted')">
          <template v-slot="{ row }">
            <el-tag size="small">{{row.perOrderedToQuoted | toPercent}}</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </native-scroll>
  </div>
</template>

<script>
import Tab from './../Tab'
import { ServicePanels } from '@/services/panels'
import { toPercent } from '@/utils/filters'

export default {
  name: 'TabHistory',
  mixins: [Tab],
  components: {
    'native-scroll': () => import(/* webpackChunkName: 'NativeScroll' */ '@/components/native-scroll'),
    'bar': () => import(/* webpackChunkName: 'ChartsReactiveBar' */ '@/components/Chart/ReactiveBar.vue'),
    'report-panel': () => import(/* webpackChunkName: 'ReportPanel' */ '@/components/UI/ReportPanel')
  },
  data () {
    return {
      isLoading: false,
      isVisibleReport: false,
      list: []
    }
  },
  computed: {
    tableData () {
      return this.list.map((item) => ({
        ...item,
        perQuotedToRequested: item.quoted / item.requested,
        perOrderedToQuoted: item.ordered / item.quoted
      }))
    },
    chartData () {
      const series = [...this.list].sort((a, b) => a.year - b.year)
      const labels = series.map(({ year }) => year)
      return {
        labels,
        datasets: [
          { label: this.L10n('number-of-pn-requested'), data: series.map(({ requested }) => requested), backgroundColor: '#9a9df9' },
          { label: this.L10n('number-of-pn-quoted'), data: series.map(({ quoted }) => quoted), backgroundColor: '#8f3964' },
          { label: this.L10n('number-of-pn-ordered-following-quote'), data: series.map(({ ordered }) => ordered), backgroundColor: '#fffed0' }
        ]
      }
    }
  },
  methods: {
    async loadData () {
      try {
        this.isLoading = true
        const customerCompanyID = this.companyID
        const { data: { value } } = await ServicePanels.getCompanyBusinessHistory({ customerCompanyID })

        this.list = value.sort((a, b) => b.year - a.year)
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.isLoading = false
      }
    },

    getSummaries (param) {
      const { columns, data } = param

      const total = data.reduce((acc, item) => {
        acc.ordered += item.ordered
        acc.quoted += item.quoted
        acc.requested += item.requested
        return acc
      }, { requested: 0, quoted: 0, ordered: 0 })

      return columns.map((column, index) => {
        if (index === 0) {
          return this.L10n('total')
        }

        const prop = column.property

        if (prop === 'perQuotedToRequested') {
          return toPercent(total.quoted / total.requested)
        }

        if (prop === 'perOrderedToQuoted') {
          return toPercent(total.ordered / total.quoted)
        }

        return data.reduce((acc, item) => {
          acc += item[prop]
          return acc
        }, 0)
      })
    },

    // Mixin Tabs
    handleChangeCompanyID () {
      this.loadData()
    }
  }
}
</script>

<style lang="stylus">
  .history-row{
    &__requested {
      background-color rgba(#9a9df9, 0.2)
    }
    &__quoted {
      background-color rgba(#8f3964, 0.2)
    }
    &__ordered {
      background-color rgba(#fffed0, 0.2)
    }
  }
  .tab-content.tab-history {
    display grid
    height 100%
    grid-template-rows auto 1fr
    & > * {
      min-width 0
    }
  }
</style>
